export function clearContainer(element) {
  while (element.firstChild) {
    element.removeChild(element.firstChild);
  }
}
